import { render, staticRenderFns } from "./CustomerRouteExpandableTable.vue?vue&type=template&id=5fbd88c7&scoped=true&"
import script from "./CustomerRouteExpandableTable.vue?vue&type=script&lang=js&"
export * from "./CustomerRouteExpandableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd88c7",
  null
  
)

export default component.exports